export const MIN_LIGHTNESS = 15;
export const MAX_LIGHTNESS = 90;
export const AVG_LIGHTNESS = 70;
export const DEFAULT_HUE = 242;
export const DEFAULT_SATURATION = 70;
